import { Data } from '@angular/router';
import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ArquivoScr } from './arquivo-src.model';
import { BaseModel } from './base-model.model';
import { Estado } from './estado.model';
import { OperacaoScr } from './operacao-scr.model';

export class ControleAgendamentoProcessoHonraBatch extends BaseModel {
	public idProcessoBatchHonra: number;
	public nomeProcessoBatchHonra: string;
	public anoMesJanela: string;
	public dataPrevistaParaPrimeiraExecucao: Date;
	public dataPrevistaParaUltimaExecucao: Date;
	public dataExecucaoExcepcional: Date;
	public sucesso: Boolean;
    public logsExecucao: LogExecucaoProcessoBatchHonraDTO[];
}

export class LogExecucaoProcessoBatchHonraDTO extends BaseModel {
	public dataReferenciaExecucao: Date;
	public execucaoRealizadaComSucesso: any;
	public tempoTotalEmSegundos: number;
}
